import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter,Routes,Route } from 'react-router-dom'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";
import ProtectedRoute from './components/protection/protectionRoute';
import AuthenticationPage from './page/auth/AuthenticationPage';
import HomePage from './page/dashboardSubmaster/HomePage';
import RegionForm from './page/dashboardSubmaster/RegionForm';
import UnitForm from './page/dashboardSubmaster/UnitFormPage';
import LocalForm from './page/dashboardSubmaster/LocalForm';
import UploadPage from './page/dashboardSubmaster/UploadPage';
import SeeContractPage from './page/dashboardSubmaster/SeeContractPage';
import ReportPage from './page/dashboardSubmaster/Report';
import NotificationPage from './page/dashboardSubmaster/Notificaiton';
import PlanSubmasterPage from './page/dashboardSubmaster/PlanSubmasterPage';
import { UserProvider } from './page/dashboardSubmaster/UserProvider';
import UserPage from './page/dashboardSubmaster/UserPage';
import CompanyPage from './page/dashboardSubmaster/CompanyPage';
import AuthUserToSubmasterPage from './page/authUserSubmaster/AuthUserToSubmasterPage';
import HomeUserToSubmasterPage from './page/dashboardUserToSubmaster/HomeUserToSubmasterPage';
import ProtectedRouteUserToSubmaster from './components/protection/protectionRouteUserToSubmaster';
import HistoryPage from './page/dashboardSubmaster/HistoryPage';



const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
        <UserProvider> 
          <Routes>
              
              <Route path="/" element={<AuthenticationPage />} />


              {/* Routes da submaster ============================================================== */}
              <Route
                path="/HomePage"
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/RegionForm"
                element={
                  <ProtectedRoute>
                    <RegionForm />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/UnitForm"
                element={
                  <ProtectedRoute>
                    <UnitForm/>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/LocalForm"
                element={
                  <ProtectedRoute>
                    <LocalForm/>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/UploadPage"
                element={
                  <ProtectedRoute>
                    <UploadPage/>
                  </ProtectedRoute>
                }
              />


              <Route
                path="/SeeContractPage"
                element={
                  <ProtectedRoute>
                    <SeeContractPage/>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/ReportPage"
                element={
                  <ProtectedRoute>
                    <ReportPage/>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/NotificationPage"
                element={
                  <ProtectedRoute>
                    <NotificationPage/>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/PlanSubmasterPage"
                element={
                  <ProtectedRoute>
                    <PlanSubmasterPage/>
                  </ProtectedRoute>
                }
              />

                <Route
                path="/UserPage"
                element={
                  <ProtectedRoute>
                    <UserPage/>
                  </ProtectedRoute>
                }
              />


              <Route
                path="/CompanyPage"
                element={
                  <ProtectedRoute>
                    <CompanyPage/>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/HistoryPage"
                element={
                  <ProtectedRoute>
                    <HistoryPage/>
                  </ProtectedRoute>
                }
              />


              <Route
                path="/AuthUserToSubmasterPage"
                element={
                  <AuthUserToSubmasterPage />
                }
              />

              <Route
                path="/HomeUserToSubmasterPage"
                element={
                  <ProtectedRouteUserToSubmaster>
                    <HomeUserToSubmasterPage />
                  </ProtectedRouteUserToSubmaster>
                }
              />



          </Routes>
       </UserProvider>      
      <ToastContainer />
    </BrowserRouter>
  </React.StrictMode>
);



